<script setup lang="ts">
import UniversalPrintSettings from "@/components/healthcare/print/UniversalPrintSettings.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-clinical-master-data-print",
    permissionKey: "page.healthcare.clinical_master_data",
  },
});
</script>

<template>
  <UniversalPrintSettings />
</template>
